import { useRef } from 'react';
import { Box } from '@mui/material';
import { ModelReplayPanel } from './ModelReplayPanel';
import { ModelComparisonPanel } from './ModelComparisonPanel';
import type { ModelComparisonHandle } from './ModelComparisonPanel';

interface ModelAbSectionProps {
  investigationId: string;
}

// Model A/B section (sub-plan 20): the replay control above the side-by-side comparison, wired so
// a completed replay refetches the comparison (the new run appears as a new column). This is the
// single insertion unit the detail mounts (behind the manage-permission gate). Layout uses MUI v7
// Box flexbox (no Grid).
export const ModelAbSection = ({ investigationId }: ModelAbSectionProps) => {
  const comparisonRef = useRef<ModelComparisonHandle>(null);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 3 }}>
      <ModelReplayPanel
        investigationId={investigationId}
        onReplayed={() => comparisonRef.current?.refetch()}
      />
      <ModelComparisonPanel ref={comparisonRef} investigationId={investigationId} />
    </Box>
  );
};

export default ModelAbSection;
